import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { SoilUnitService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SoilUnitCreateDto,
  SoilUnitDto,
  SoilUnitExcelDownloadDto,
  SoilUnitUpdateDto,
} from '../proxy/planning/dtos/soil-unit';
import { SOILUNIT_CONFIG, SOILUNIT_FIELDS } from './soil-unit.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-soil-unit',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SoilUnitService, ConfirmationService],
  templateUrl: './soil-unit.html',
  styleUrl: './soil-unit.scss',
})
export class SoilUnit extends BaseCrudComponent<
  SoilUnitDto,
  SoilUnitCreateDto,
  SoilUnitUpdateDto,
  SoilUnitExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(SoilUnitService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('SoilUnit', ids),
  };
  config = SOILUNIT_CONFIG;
  fields = SOILUNIT_FIELDS;

  protected prepareUpdateDto(data: any, selected: SoilUnitDto): SoilUnitUpdateDto {
    return {
      name: data.name,
      soilUnitArea: data.soilUnitArea,
      isForestPriority: data.isForestPriority,
      productivityIndex: data.productivityIndex,
      soilAptitudeId: data.soilAptitudeId,
      specificConsumptionTypeId: data.specificConsumptionTypeId,
      soilGroupId: data.soilGroupId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SoilUnit';
  }
}
